import * as React from 'react';
import {connect} from "react-redux";
import {Contract} from "../../models/Contract";
import {ApplicationState} from "../../store";
import {ContractList}  from '../components/ContractList';
import {ColumnData} from '../../models/ColumnData';
import {AppStore} from "../../desktop";
import {ContractsActionTypes} from "../../store/contracts";
import {Button} from "@material-ui/core";
import {Tab, TabTypes} from "../Tab";
import {TabsService} from "../TabsService";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {actionContractDelete, actionDeleteContracts} from '../../store/contracts/actions';
import {t} from "../../core/localization";
import {Customer} from "../../models/Customer";

export interface ContractsTabProps {
	contracts: Contract[]
	customers: Customer[]
	tab: Tab
}

export interface ContractsTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		contracts: state.contracts.list,
		customers: state.customers.list,
		tab: state.tabs.active
	};
}

class ContractsTab extends React.Component<ContractsTabProps, ContractsTabState> {

	constructor(props: ContractsTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: ContractsTabProps) {
	}

	componentDidMount() {
		this.loadData()
	}

	onOpenClick(contract: Contract){
		TabsService.createTab(t.Contract + ': ' + contract.title, TabTypes.CONTRACTS_NEW, contract)
	}

	onCopyClick(contract: Contract){
		TabsService.createTab(t.Contract + ': ' + contract.title, TabTypes.CONTRACTS_NEW, { ...contract, id: null })
	}

	onDeleteClick(contract: Contract){
		actionContractDelete(contract);
	}

	onActionDeleteClick(contracts: Contract[]){
		actionDeleteContracts(contracts);
	}

	onNewClick() {
		TabsService.createTab(t.NewContract, TabTypes.CONTRACTS_NEW, new Contract())
	}

	render(): React.ReactNode {

		const {contracts} = this.props;

		var customersMap = this.props.customers.reduce(function(map: any, obj: any) {
			map[obj.id] = obj.title;
			return map;
		}, {});

		const columns = [
			new ColumnData(t.Title, "title"),
			new ColumnData(t.Number, "number"),
			new ColumnData(t.Customer, "customerId", customersMap),
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewContract}</Button></div>
				<ContractList
					columns={columns}
					items={contracts}
					title={t.Contracts}
					onOpenClick={(contract: Contract) => this.onOpenClick(contract)}
					onCopyClick={(contract: Contract) => this.onCopyClick(contract)}
					onDeleteClick={(contract: Contract) => this.onDeleteClick(contract)}
					onActionDeleteClick={(contracts: Contract[]) => this.onActionDeleteClick(contracts)}
					tab={this.props.tab}
				/>
			</div>
		);
	}

	private loadData() {
		AppStore.dispatch({type: ContractsActionTypes.FETCH_ALL_REQUEST})
	}
}

export default connect(mapStateToProps)(ContractsTab);
